import React, {useState} from 'react';

function SurveysFilter(props) {

    const filtersMap = {
        "All": null,
        "Active Surveys": "ACTIVE",
        "Draft surveys": "DRAFT",
        "Closed surveys": "CLOSED"
    }

    const [isFilterToggled, setIsFilterToggled] = useState(false);

    function onSurveysFilterClick(){
        setIsFilterToggled(!isFilterToggled);
    }

    let filtersHtmlList = Object.keys(filtersMap).map((key, index) => {
        let filterSurveyStatus = filtersMap[key];
        return (
            <li key={"surveys_filter_button_" + index}><a href="javascript:void(0)" onClick={() => {props.filterFunction(filterSurveyStatus)} }>{key}</a></li>
        )
    });

    return (
        <div className="surveys__menu__filters__type" onClick={onSurveysFilterClick}>
            <div className="surveys__menu__filters__type__icon"></div>
            <ul className="surveys__menu__filters__type__list" style={{display: (isFilterToggled ? "block": "none")}}>
                { filtersHtmlList }
            </ul>
        </div>
    )
}

export default SurveysFilter;